import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {configData} from "../../config";

export default function CurrencyConverter({ price }) {

    const [selectedCountry, setSelectedCountry] = useState("GB");
    const [countrieslist, setCountriesList] = useState({});
    const [convertedText, setConvertedText] = useState("");
    const [priceContainer, setPriceContainer] = useState(null);
    // The live page first shows the price in dollars with no country list ("APPROXIMATELY $1950")
    // and loads its converter script a while after the page is ready: after 10 seconds on a
    // phone-sized window (narrower or shorter than 480px), after 1 second otherwise. Until then
    // the box shows what live's page shows.
    const [converterLoaded, setConverterLoaded] = useState(false);
    const converterRef = useRef(null);
    const app_url = configData.APP_URL;
    // On the Drupal site the converted price is its own block under the table that holds
    // the country list and the globe. The converter is mounted inside that table, so make
    // a place for the price right after the block the table is in.
    useEffect(() => {
        const tableBlock = converterRef.current.closest('.payment_description');
        if (!tableBlock) return;

        const container = document.createElement('div');
        tableBlock.after(container);
        setPriceContainer(container);
        return () => container.remove();
    }, []);
    useEffect(() => {
        const phoneSized = window.innerWidth < 480 || window.innerHeight < 480;
        const timer = setTimeout(() => setConverterLoaded(true), phoneSized ? 10000 : 1000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (!converterLoaded) return;
        retrieveCountriesList();
        getCurrencyCalculation(selectedCountry);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [converterLoaded]);
async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    // By name, as the live site lists them (the API returns them in the order they were added)
    const countries = countrieslistdata.data.result;
    setCountriesList(Array.isArray(countries) ? [...countries].sort((a, b) => a.label.localeCompare(b.label)) : countries);
   
    
    
  }
  const getCurrencyCalculation = async (country) => {
    // When no price comes back the line is emptied, so the price of the
    // previously selected country is never left on screen
    let text = "";
    try {
      const postData = {
           country: country,
           price:price
          };
      const response = await fetch(app_url + 'coursepages/getcountryprice', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
        'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if(data.data && data.data.msg === "Success") {
        text = data.data.text;
      }
    } catch (err) {
      console.error(err);
    }
    setConvertedText(text);
};
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    getCurrencyCalculation(e.target.value);
};
    // Before the converter loads: the live page's own price line, the course price in dollars as
    // the page stores it (no thousands separator: "$1950")
    const convertedPrice = converterLoaded ? (
        <div
            className="payment_description converted_price"
            dangerouslySetInnerHTML={{ __html: convertedText }}
        ></div>
    ) : (
        <div className="payment_description" style={{marginTop: 0}}>
            <span className="pay_heading approx" style={{verticalAlign: "middle", float: "left", paddingRight: 10}}>APPROXIMATELY </span>
            <b><span className="currency_unprocessed_price" style={{display: "block", paddingRight: "4%"}}>${price}</span></b>
        </div>
    );
    return (
        <div className="currency-converter" ref={converterRef}>
            {converterLoaded ? <span className="pay_heading">PRICE IN </span> : (
                // Live's markup before its converter loads: the heading, then an empty spacer
                // (the 14px gap the heading has once the list is there would add to it)
                <>
                    <span className="pay_heading" style={{marginRight: 0}}>PRICE IN </span>{' '}
                    <span style={{fontSize: "13px"}}><b><span className="currency_unprocessed" style={{marginRight: 10}}>{'\u00a0'}</span></b></span>
                </>
            )}

            {converterLoaded && <select id= "currency_select_0"
                value={selectedCountry}
                onChange={handleCountryChange}
            >
                {/* The live site's top countries, then a line, then all countries */}
                <option className="bold" value="AU">Australia</option>
                <option className="bold" value="CA">Canada</option>
                <option className="bold" value="IN">India</option>
                <option className="bold" value="JP">Japan</option>
                <option className="bold" value="GB">United Kingdom</option>
                <option className="bold" value="US">United States</option>
                <option disabled role="separator">—————————————————</option>
                 {Array.isArray(countrieslist) &&countrieslist.map((country) => (
        <option key={country.value} value={country.value}>
            {country.label}
        </option>
    ))}
            </select>}
            {priceContainer ? createPortal(convertedPrice, priceContainer) : convertedPrice}
        </div>
    );
}